import {isServer} from '@adv-mt/mt-utils'

import UserServicesFactory from '../../user/Services/factory.js'
import FetcherRepositoriesFactory from '../Repositories/factory.js'
import GetAuthenticationTokenService from './GetAuthenticationTokenService.js'

export default class FetcherServicesFactory {
  static getAuthenticationTokenService = ({config}) =>
    new GetAuthenticationTokenService({
      config,
      localRepository: isServer
        ? FetcherRepositoriesFactory.configFetcherRepository({config})
        : FetcherRepositoriesFactory.cookieFetcherRepository({config}),
      remoteRepository: FetcherRepositoriesFactory.httpFetcherRepository({
        config
      }),
      getCurrentUserService: UserServicesFactory.getCurrentUserService({config})
    })
}
